import React from "react";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import ConsultationForm from "@/components/ConsultationForm";
import { WHATSAPP_URL } from "@/components/WhatsAppButton";

const Consultation = () => (
  <div data-testid="consultation-page">
    <SEO
      title="Book a Private ACRE Consultation"
      description="Book a private consultation with ACRE — Al Casa Real Estate. Discuss Dubai, Abu Dhabi, Ras Al Khaimah & Al Marjan Island and Land & JV opportunities with our advisery team."
      path="/private-consultation"
      keywords="Dubai property investment for UK buyers, buying property in Dubai as a UK citizen, Al Marjan Island property investment"
    />
    <section className="pt-36 pb-24" data-testid="consultation-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14">
        <div>
          <Reveal>
            <p className="eyebrow mb-5">Private Consultation</p>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light text-[#F4F3EF] leading-[1.08] mb-7">
              Begin with a<br />
              <span className="italic text-gold-gradient">private conversation.</span>
            </h1>
            <p className="text-lg text-[#9DA3AE] font-light leading-relaxed max-w-lg mb-12">
              No obligation and no pressure. Tell us what you are considering — a second home, an investment, a Golden
              Visa, land and development — and an ACRE adviser will respond personally.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="space-y-6">
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="consultation-whatsapp-link" className="flex items-center gap-4 group">
                <span className="w-11 h-11 rounded-full bg-[#0E382B] border border-[rgba(197,168,128,0.35)] flex items-center justify-center group-hover:border-[#C5A880] transition-colors">
                  <MessageCircle size={18} className="text-[#E6CA65]" />
                </span>
                <span>
                  <span className="text-sm text-[#F4F3EF] block group-hover:text-[#E6CA65] transition-colors">WhatsApp us directly</span>
                  <span className="text-xs text-[#9DA3AE]">+971 58 586 2273</span>
                </span>
              </a>
              <a href="tel:+971585862273" data-testid="consultation-phone-link" className="flex items-center gap-4 group">
                <span className="w-11 h-11 rounded-full bg-[#13151D] border border-[rgba(197,168,128,0.25)] flex items-center justify-center group-hover:border-[#C5A880] transition-colors">
                  <Phone size={18} className="text-[#E6CA65]" />
                </span>
                <span>
                  <span className="text-sm text-[#F4F3EF] block group-hover:text-[#E6CA65] transition-colors">Call the advisery desk</span>
                  <span className="text-xs text-[#9DA3AE]">+971 58 586 2273</span>
                </span>
              </a>
              <a href="mailto:ceo@alcasa.ae" data-testid="consultation-email-link" className="flex items-center gap-4 group">
                <span className="w-11 h-11 rounded-full bg-[#13151D] border border-[rgba(197,168,128,0.25)] flex items-center justify-center group-hover:border-[#C5A880] transition-colors">
                  <Mail size={18} className="text-[#E6CA65]" />
                </span>
                <span>
                  <span className="text-sm text-[#F4F3EF] block group-hover:text-[#E6CA65] transition-colors">Email us</span>
                  <span className="text-xs text-[#9DA3AE]">ceo@alcasa.ae</span>
                </span>
              </a>
              <p className="flex items-center gap-4">
                <span className="w-11 h-11 rounded-full bg-[#13151D] border border-[rgba(197,168,128,0.25)] flex items-center justify-center">
                  <MapPin size={18} className="text-[#E6CA65]" />
                </span>
                <span>
                  <span className="text-sm text-[#F4F3EF] block">Where we work</span>
                  <span className="text-xs text-[#9DA3AE]">London &amp; UAE | Private consultations by appointment</span>
                </span>
              </p>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <ConsultationForm />
        </Reveal>
      </div>
    </section>
  </div>
);

export default Consultation;
